/**
 * Helper functions for left nav accordion behavior
 */

export const getParentPath = (path) => {
    const parts = path.split('/').filter(Boolean)
    if (parts.length <= 1) return ''
    return `/${parts.slice(0, -1).join('/')}`
}

export const getSiblingPaths = (targetPath, allPaths) => {
    const targetParent = getParentPath(targetPath)
    return allPaths.filter((path) => {
        const pathParent = getParentPath(path)
        return pathParent === targetParent && path !== targetPath
    })
}

export const getChildPaths = (parentPath, allPaths) => {
    return allPaths.filter((path) => path.startsWith(`${parentPath}`))
}

export const getAllPaths = (nodes, allPaths = []) => {
    nodes.forEach((node) => {
        if (node?.path) {
            allPaths.push(node.path)
        }
        if (node?.metadataChildren) {
            getAllPaths(node.metadataChildren, allPaths)
        }
    })
    return allPaths
}

export const getInitialExpandedPaths = (metadata) => {
    const initialPaths = {}
    if (metadata?.path) {
        const pathParts = metadata.path.split('/').filter(Boolean)
        for (let i = 1; i <= pathParts.length; i++) {
            const partialPath = `/${pathParts.slice(0, i).join('/')}/`
            if (partialPath !== metadata.path) {
                initialPaths[partialPath] = true
            }
        }
    }
    return initialPaths
}
